import { useTranslation } from 'next-i18next'
import { css } from '@emotion/react'

import Button from '@/components/common/Button'
import { Parking } from '@/service'

import { getParkingAddress } from '@/utils/getParkingAddress'
import { getParkingLabel } from '@/utils/getParkingLabel'
import { useMapTracking } from '@/hooks/useMapTracking'

import CustomMapButtons from '../home/SearchNearParking/CustomMapButtons/CustomMapButtons'

import {
  ButtonWrapper,
  IconWrapper,
  ImageWrapper,
  InfoWrapper,
  ParkingInfo,
  Title,
  Wrapper,
  SubText
} from './CustomPopup.styled'

interface Props {
  parking: Parking
  customButtons?: boolean
}

function CustomPopup(props: Props) {
  const { t } = useTranslation('parkings')
  const { parking, customButtons } = props
  const { trackMapInteraction } = useMapTracking()

  const handlePopupClick = () => {
    trackMapInteraction('MAP_PARKING_TILE_CLICK', parking)
  }

  const handleDetailsClick = () => {
    trackMapInteraction('MAP_PARKING_DETAILS', parking)
  }

  return (
    <Wrapper
      data-test-id={`parkings-map-tile-${parking.urlSlug}`}
      onClick={handlePopupClick}
    >
      <ImageWrapper>
        <img
          src={parking.mainPictureUrl}
          alt={parking.shortDisplayName}
          css={imageStyle}
        />
      </ImageWrapper>
      <InfoWrapper>
        <IconWrapper>
          <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.445 10.923a1.49 1.49 0 0 0-1.49-1.49h-.036c-.823 0-1.472.667-1.472 1.49 0 .822.685 1.49 1.508 1.49a1.49 1.49 0 0 0 1.49-1.49zM13.937 2.98c-4.594 0-8.332 3.738-8.332 8.332 0 4.618 5.363 10.255 8.33 12.845 2.969-2.594 8.333-8.236 8.333-12.845 0-4.594-3.737-8.332-8.331-8.332zm0 25.02-.926-.733c-.424-.335-10.386-8.318-10.386-15.955C2.625 5.074 7.699 0 13.937 0c6.236 0 11.312 5.074 11.312 11.312 0 7.637-9.962 15.62-10.387 15.955l-.925.733z"
              fill="#093769"
              fillRule="evenodd"
            />
          </svg>
        </IconWrapper>
        <ParkingInfo>
          <Title>{getParkingLabel(parking, t)}</Title>
          <SubText>{getParkingAddress(parking, t)}</SubText>
        </ParkingInfo>
      </InfoWrapper>
      {customButtons ? (
        <CustomMapButtons parking={parking} />
      ) : (
        <ButtonWrapper>
          <Button
            link={{
              pathname: '/parkings/[city]/[slug]',
              query: {
                city: parking.cityUrlSlug,
                slug: parking.urlSlug
              }
            }}
            text={t(`buttonDetails`)}
            onClick={handleDetailsClick}
          />
        </ButtonWrapper>
      )}
    </Wrapper>
  )
}

const imageStyle = css`
  width: 100%;
  height: 100%;
`

export default CustomPopup
